import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@shared/ui/dialog";
import { Button } from "@shared/ui/button";

interface VersionDetailDialogProps {
  isOpen: boolean;
  onClose: () => void;
  versionData: any;
}

export const VersionDetailDialog: React.FC<VersionDetailDialogProps> = ({
  isOpen,
  onClose,
  versionData,
}) => {
  if (!versionData) return null;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[550px] p-0 gap-0">
        <div className="p-6 pb-4">
          <DialogHeader>
            <DialogTitle className="text-lg font-bold">
              Changes in {versionData.versionTag}
            </DialogTitle>
          </DialogHeader>
        </div>

        <div className="px-6 py-4 border-t border-gray-100">
          <p className="text-sm text-gray-500 mb-6 font-medium">
            By {versionData.createdUserRemoteName || "N/A"} ·{" "}
            {versionData.createdDate || "N/A"}
          </p>

          <div className="flex overflow-hidden rounded-lg border border-emerald-100 bg-emerald-50/50">
            <div className="w-1.5 bg-emerald-600 shrink-0" />

            <div className="flex gap-8 p-4 items-start w-full">
              <span className="text-emerald-700 font-bold text-xs whitespace-nowrap pt-0.5">
                + Added
              </span>
              <div className="flex flex-col gap-1">
                <span className="text-[10px] font-bold text-gray-500 tracking-wider">
                  Field Mapping
                </span>
                <span className="text-sm text-gray-800">
                  {versionData.changeSummary ||
                    "tax_amount → taxes.surcharge (decimal, no transform)"}
                </span>
              </div>
            </div>
          </div>
        </div>

        <DialogFooter className="p-6 py-4 border-t border-gray-100">
          <Button variant="outline" onClick={onClose} className="bg-white">
            Cancel
          </Button>
          <Button
            className="bg-indigo-600 hover:bg-indigo-700 text-white"
            onClick={onClose}
          >
            Close
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
